import { useEffect } from 'react';

import { useVariableOptions, useStatusOptions } from '@restworld/utils-common';
import { Status, Variable } from '@restworld/utility-types';

/**
 * Custom hook that fetches and provides options for worker fields.
 * @param options.isFetchVariableOptions - Flag indicating whether to fetch variable options. Default is true.
 * @param options.isFetchStatusOptions - Flag indicating whether to fetch status options. Default is true.
 * @returns Object containing options for various worker fields.
 */
const useWorkerFieldOptions = (props?: { isFetchVariableOptions?: boolean; isFetchStatusOptions?: boolean }) => {
  const { isFetchVariableOptions = true, isFetchStatusOptions = true } = props || {};
  const { fetchVariable, variableOptions } = useVariableOptions();
  const { fetchStatus, statusOptions } = useStatusOptions();
  useEffect(() => {
    try {
      if (isFetchVariableOptions)
        fetchVariable([
          'sex',
          'driving_license',
          // 'vehicle_availability',
          'displacement_availability',
          'displacement_preference',
          'domain_interest',
          'restaurant_type',
          'education_title',
          'shifts',
          'languages',
          'language_level_cefr',
          'certificate_type',
          'transportation_options',
          'job_type',
          'communication_channel_preference_worker',
          'professional_association',
        ]);
    } catch (error) {
      /* */
    }
  }, [fetchVariable, isFetchVariableOptions]);
  useEffect(() => {
    try {
      if (isFetchStatusOptions) fetchStatus(['worker_research_status']);
    } catch (error) {
      /* */
    }
  }, [fetchStatus, isFetchStatusOptions]);
  return {
    sexOptions: variableOptions?.['sex'] ?? [],
    drivingLicenseOptions: variableOptions?.['driving_license'] ?? [],
    transportationOptions: variableOptions?.['transportation_options'] ?? [],
    // vehicleAvailability: variableOptions?.['vehicle_availability'] ?? [],
    displacementAvailability: variableOptions?.['displacement_availability'] ?? [],
    displacementPreference: variableOptions?.['displacement_preference'] ?? [],
    domainInterest: variableOptions?.['domain_interest'] ?? [],
    restaurantType: variableOptions?.['restaurant_type'] ?? [],
    educationTitle: variableOptions?.['education_title'] ?? [],
    shifts: variableOptions?.['shifts'] ?? [],
    certificateType: variableOptions?.['certificate_type'] ?? [],
    workerResearchStatus: statusOptions?.['worker_research_status'] ?? [],
    languages: variableOptions?.['languages'] ?? [],
    languageLevelCertificate: variableOptions?.['language_level_cefr'] ?? [],
    jobType: variableOptions?.['job_type'] ?? [],
    communicationChannelPreferenceOptions: variableOptions?.['communication_channel_preference_worker'] ?? [],
    professionalAssociations: variableOptions?.['professional_association'] ?? [],
  };
};

type FieldOptionsType = {
  sexOptions: Variable[];
  drivingLicenseOptions: Variable[];
  // vehicleAvailability: Variable[];
  displacementAvailability: Variable[];
  displacementPreference: Variable[];
  domainInterest: Variable[];
  restaurantType: Variable[];
  educationTitle: Variable[];
  shifts: Variable[];
  languages: Variable[];
  languageLevelCertificate: Variable[];
  certificateType: Variable[];
  transportationOptions: Variable[];
  workerResearchStatus: Status[];
  jobType: Variable[];
  communicationChannelPreferenceOptions: Variable[];
  professionalAssociations: Variable[];
};
export { useWorkerFieldOptions };
export type { FieldOptionsType };
